/* em-collection.js - the collection grid's behaviour: sort into the URL, the
   next page on request, the counts on the type pills, add from a card. */
(function () {
  'use strict';
  var sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(location.href);
    if (sort.value === 'manual') u.searchParams.delete('sort_by'); else u.searchParams.set('sort_by', sort.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  });

  /* Twenty-four to begin with and the rest a tap away (em-more.js): the next
     page is this same section rendered by Shopify, and its cards are appended. */
  var grid = document.getElementById('jgrid');
  var tray = document.querySelector('[data-more]');
  var sectionId = (grid && grid.closest('.shopify-section') || {}).id;
  if (grid && tray) tray.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-next]'); if (!btn) return;
    var next = btn.getAttribute('data-next');
    btn.disabled = true; btn.textContent = 'Loading';
    var u = new URL(next, location.href);
    /* a preview on ?view= keeps its template for the next page too */
    var view = new URLSearchParams(location.search).get('view');
    if (view && !u.searchParams.has('view')) u.searchParams.set('view', view);
    if (sectionId) u.searchParams.set('section_id', sectionId.replace(/^shopify-section-/, ''));
    fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var cards = doc.querySelectorAll('#jgrid > .jcard');
      var frag = document.createDocumentFragment();
      cards.forEach(function (c) { frag.appendChild(c); });
      grid.appendChild(frag);
      var total = Number(grid.getAttribute('data-total')) || grid.children.length;
      var shown = grid.querySelectorAll('.jcard').length;
      var nb = doc.querySelector('[data-next]');
      if (nb && shown < total) {
        btn.disabled = false;
        btn.setAttribute('data-next', nb.getAttribute('data-next'));
        btn.textContent = 'Load ' + Math.min(24, total - shown) + ' more';
        var c = tray.querySelector('.em-more-count'); if (c) c.textContent = shown + ' of ' + total;
      } else {
        var done = document.createElement('p');
        done.className = 'em-more-done'; done.setAttribute('tabindex', '-1');
        done.textContent = 'All ' + shown + ' shown';
        tray.innerHTML = ''; tray.appendChild(done); done.focus();
      }
    }).catch(function () { btn.disabled = false; btn.textContent = 'Load more'; });
  });

  /* the count on each type pill: the collection filtered by that tag, counted by
     the count view, one small request each, cached by the CDN */
  document.querySelectorAll('.typerow [data-count]').forEach(function (a) {
    var n = a.querySelector('.n'); if (!n) return;
    fetch(a.getAttribute('data-count')).then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) {
        t = String(t).trim(); if (!/^\d+$/.test(t)) return;
        n.textContent = t;
        /* Sept 14 (QA): a kind with nothing in the current filter isn't offered */
        if (t === '0' && !a.classList.contains('on')) a.hidden = true;
      }).catch(function () {});
  });

  /* Add to Bag on a card: the one variant, straight into Shopify's cart */
  if (grid) grid.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-add]'); if (!b || !window.EMCart) return;
    b.disabled = true;
    EMCart.add([{ id: Number(b.getAttribute('data-add')), quantity: 1 }]).then(function () {
      b.textContent = 'Added to bag'; b.classList.add('done');
      setTimeout(function () { b.textContent = 'Add to Bag'; b.classList.remove('done'); b.disabled = false; }, 1600);
    }).catch(function () { b.disabled = false; });
  });
})();
